import { Stack, stackClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "DrawerBody";

export const classes = {
  root: `${PREFIX}-root`,
  descriptions: `${PREFIX}-descriptions`,
  cards: `${PREFIX}-cards`,
};

export const DrawerBody = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexDirection: "row",
    alignItems: "start",
    gap: theme.spacing(4),
    [`& .${classes.descriptions}`]: {
      flex: "auto",
      gap: theme.spacing(4),
      overflow: "auto",
      [`& > .${stackClasses.root}`]: {
        gap: theme.spacing(1),
      },
    },
    [`& .${classes.cards}`]: {
      gap: theme.spacing(2),
    },
  },
}));
